const colorAccent = '#9999FF';
const colorBright = '#fff';
const colorDark = '#000';
const colorGrey = '#808080';

export const invert = theme => {
  return {
    ...theme,
    colorText: theme.colorBright,
    colorBackground: theme.colorDark,
    colorInputBorder: '#444',
  };
};

export default {
  colorAccent,
  colorDark,
  colorBright,
  colorLink: colorAccent,
  colorText: colorDark,
  colorBackground: colorBright,
  colorMinor: colorGrey,
  colorInputBorder: colorGrey,
};



// WEBPACK FOOTER //
// ./src/utils/theme.js